/* eslint-disable @typescript-eslint/explicit-function-return-type */
import type { Component } from 'solid-js';

export interface CustomErrorProps {
  msg: string;
  id?: string;
}

const CustomError: Component<CustomErrorProps> = (props) => {
  const getMessage = () => props.msg;

  return (
    <label class="error-message" id={props.id}>
      {getMessage()}
    </label>
  );
};

export default CustomError;
